import * as React from 'react';

import { AnalyticsStore } from 'bernie-core';
import { ErrorBoundary } from 'bernie-view';

import { ProgressIndicator } from '@shared-ui/multi-item-progress-indicator';

import { UitkSpacing } from 'uitk-react-spacing';

type ProgressIndicatorProps = {
  multiItemSessionId: string;
  analytics: AnalyticsStore;
};

export const MultiItemProgressIndicator: React.FunctionComponent<ProgressIndicatorProps> = ({ multiItemSessionId, analytics }) => {
  const errorCallback = () => {
    analytics.trackEvent('MIT.PROGRESS.INDICATOR.ERROR', 'RFRR Action Event', analytics.omnitureData, null, true);
  };
  const changeLinkCallBack = (rfrr: string, linkName: string, event: React.UIEvent) => {
    analytics.trackEvent(rfrr, linkName, analytics.omnitureData, event, true);
  };

  return (
    <ErrorBoundary label="progress-indicator">
      <UitkSpacing padding={{ small: { block: 'three' }, medium: { blockstart: 'one' }, large: { blockstart: 'three' } }}>
        <div>
          <ProgressIndicator
            inputs={{ multiItemSessionId }}
            showLoadingState={true}
            changeLinkClickCallback={changeLinkCallBack}
            errorCallback={errorCallback}
          />
        </div>
      </UitkSpacing>
    </ErrorBoundary>
  );
};
